export function getPatternSaveError(error) {
  const technicalMessage = error?.message || String(error || '');
  const normalized = technicalMessage.toLowerCase();

  if (normalized.includes('bucket not found')) {
    return {
      title: 'File storage is not ready',
      message: 'The PDF or image storage is unavailable. Your work is still here; retry after the storage configuration is restored.',
      technicalMessage,
    };
  }

  if (normalized.includes('row-level security') || normalized.includes('permission')) {
    return {
      title: 'Upload permission denied',
      message: 'The files could not be uploaded with the current permissions. Your draft has been kept so you can retry.',
      technicalMessage,
    };
  }

  if (normalized.includes('duplicate') || normalized.includes('unique')) {
    return {
      title: 'This pattern URL is already in use',
      message: 'Choose a different slug, then try saving again.',
      technicalMessage,
    };
  }

  if (normalized.includes('fetch') || normalized.includes('network') || normalized.includes('offline')) {
    return {
      title: 'Connection interrupted',
      message: 'Check your connection and retry. The form and selected files have not been cleared.',
      technicalMessage,
    };
  }

  return {
    title: 'The pattern could not be saved',
    message: 'Your work is still available in this form and a local draft has been kept. Please retry.',
    technicalMessage,
  };
}
